'use client';

import { forwardRef } from 'react';
import clsx from 'clsx';

import { useAccordionContext } from '../contexts/accordion-context';
import { useAccordionItemContext } from '../contexts/accordion-item-context';

interface AccordionHeaderProps {
	as?: React.ElementType;
	className?: string;
	buttonClassName?: string;
	children: React.ReactNode;
}

export const AccordionHeader = forwardRef<HTMLElement, AccordionHeaderProps>(function AccordionHeader(
	{ 
		as, 
		className, 
		buttonClassName, 
		children, 
		...props 
	},
	ref
) {
	const Component = as || 'div';
	const { changeSelection } = useAccordionContext();
	const { itemKey } = useAccordionItemContext();

	const handleExpend = () => {
		changeSelection(itemKey);
	};

	return (
		<Component 
			ref={ref}
			className={clsx('accordion__header', className)}
			{...props}
		>
			<button 
				className={clsx('accordion__btn', buttonClassName)}
				onClick={handleExpend}
			>
				{children}
			</button>
		</Component>
	);
});